
import React from 'react'
import Box from './Box'


/**
 * FormField component.
 */

export default function FormField({ name, label, hint, children, ...props }) {
  return <Box className="FormField" {...props}>
    {label && <label htmlFor={name}>{label}</label>}
    {children}
    {hint && <div className="hint">{hint}</div>}
  </Box>
}